import { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faBarsStaggered,
  faSearch,
  faCartShopping,
  faX,
} from "@fortawesome/free-solid-svg-icons";
import ThemeToggle from "./ThemeToggle";
import { NavLink } from "react-router-dom";
import { getCategories } from "../services/categories.services";
import { formatDateMDDYYYY } from "../utils/Date.util";

const Header = () => {
  const [categories, setCategories] = useState([]);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const fetchCategories = async () => {
    const categories = await getCategories();
    setCategories(categories);
  };

  useEffect(() => {
    fetchCategories();
  }, []);

  return (
    <>
      <div
        className={`th-menu-wrapper ${isMenuOpen ? "th-body-visible" : ""}`}
        onClick={toggleMenu}
      >
        <div className="th-menu-area text-center">
          <button className="th-menu-toggle" onClick={toggleMenu}>
            <i className="fal fa-times"></i>
          </button>
          <div className="mobile-logo">
            <NavLink to="/">
              <img src="/assets/img/RedLines-Logo-White.svg" alt="Tnews" width={"200"} />
            </NavLink>
          </div>
          <div className="th-mobile-menu">
            <ul>
              <li>
                <NavLink to="/">Home</NavLink>
              </li>
              {categories.map((category, index) => {
                return (
                  <li key={index}>
                    <NavLink
                      to={`/category/${category.name}`}
                      state={{ name: category.name }}
                    >
                      {category.name}
                    </NavLink>
                  </li>
                );
              })}
            </ul>
          </div>
        </div>
      </div>
      <header className="th-header header-layout2">
        <div className="header-top" style={{ backgroundColor: "#1e1e1e" }}>
          <div className="container">
            <div className="row align-items-center gy-2">
              <div className="col-lg-3 col-md-4">
                <p className="mb-0" style={{ color: "white" }}>
                  {formatDateMDDYYYY(Date.now())}
                </p>
              </div>
              <div className="col-lg-6 col-md-4 text-center">
                <div className="header-logo">
                  <a href="/">
                    <img
                      src="/assets/img/RedLines-Logo-White.svg"
                      alt="Tnews"
                      width="175px"
                    />
                  </a>
                </div>
              </div>
              <div className="col-lg-3 col-md-4 text-right d-flex align-items-center justify-content-end">
                <div className="header-links">
                  <ul>
                    <li>
                      <a href="about.html" style={{ color: "white", marginRight: "16px" }}>
                        MailUs
                      </a>
                    </li>
                  </ul>
                </div>
                <div className="header-icon">
                  <ThemeToggle />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="sticky-wrapper">
          <div className="menu-area">
            <div className="container">
              <div className="row align-items-center justify-content-between">
                <div className="col-auto d-lg-none d-block">
                  <div className="header-logo">
                    <a href="/">
                      <img
                        src="/assets/img/RedLines-Logo-White.svg"
                        alt="Tnews"
                      />
                    </a>
                  </div>
                </div>
                <div className="col-auto">
                  <nav className="main-menu d-none d-lg-inline-block">
                    <ul>
                      <li>
                        <NavLink to="/">Home</NavLink>
                      </li>
                      {categories.map((category, index) => {
                        return (
                          <li key={index}>
                            <NavLink
                              to={`/category/${category.name}`}
                              state={{ name: category.name }}
                            >
                              {category.name}
                            </NavLink>
                          </li>
                        );
                      })}
                    </ul>
                  </nav>
                </div>
                <div className="col-auto">
                  <div className="header-button">
                    
                    <button
                      type="button"
                      className="th-menu-toggle d-block d-lg-none"
                      onClick={toggleMenu}
                    >
                      <i className="far fa-bars"></i>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </header>
    </>
  );
};

export default Header;
